import { useEffect, useRef } from 'react'
import { analytics } from './analytics'

export function useAnalyticsScreen(path: string, visible: boolean, product: string) {
  useEffect(() => { if (visible) analytics.screen(path, product) }, [path, visible, product])
}

export function useAnalyticsView(interaction: 'journeyViewed' | 'tasksViewed' | 'pricingViewed', visible: boolean) {
  const sent = useRef(false)
  useEffect(() => {
    if (visible && !sent.current) sent.current = analytics.track(interaction)
  }, [interaction, visible])
}
